import { Carousel } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ImageProduct from "../component/ImageProduct";
import Countdown, { zeroPad } from "react-countdown";
import { mediaQueryPoint, useMediaQuery } from "../utils/hooks";
import BannerHomeMobile from "../component/BannerHomeMobile";
import { useDispatch, useSelector } from 'react-redux';
import { getBannerHome, getBidProduct, getUpNextProduct, setReduxDataTypeIntroTour } from '../Redux/futures/home/actions';
import { curStateAccount, curStateHome, curStateRightWeb } from '../Redux/selector';
import { currentDate, KEY_LOCAL_TYPE_USER, TYPE_USER } from '../helper/const';
import moment from 'moment';
import { getHistoryBid, resetBidHistory, setIdCurrentProduct } from '../Redux/futures/rightWeb/actions';
import ModalDescriptionBid from '../component/ModalDescriptionBid';
import { useLocation, useNavigate } from 'react-router';
import PATH from '../config/PATH';
import ModalWinner from '../component/ModalWinner';
import { getResultProduct } from '../Redux/futures/result/action';
import styled from "styled-components";
import { getItemCookie, getWinnerPopup } from "../utils/cookie";
import AuctionIntroTour from "./components/components/AuctionIntroTour";
import IntroTourHome from "./components/components/IntroTourHome";
import Home from "./Home";
import { getCurrentUser, getTurnRemain } from '@/Redux/futures/account/actions';
import { hasAuthCookie } from '@/utils/auth';


function HomePage() {
	const dispatch = useDispatch()
	const selectorHome = useSelector(curStateHome)
	const selectorAccount = useSelector(curStateAccount)
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
	const [currentProduct, setCurrentProduct] = useState([])
	const [selectedProduct, setSelectedProduct] = useState(null)
	const [results, setResults] = useState([])
	const selectorRightWeb = useSelector(curStateRightWeb)
	const [sort, setSort] = useState('desc')
	const [page, setPage] = useState(1)

	const isAuthed =
		hasAuthCookie() || Boolean(selectorAccount?.userInfo) || Boolean(selectorAccount?.token);

	useEffect(() => {
		dispatch(getBidProduct({}));
	}, []);

	useEffect(() => {
		isAuthed && dispatch(getTurnRemain({}));
	}, [isAuthed]);

	useEffect(() => {
		if (selectorHome?.bidProduct?.length > 0) {
			let currentProduct = selectorHome.bidProduct.filter(
				(product) => new Date(product?.start_time).getTime() < currentDate
			);
			if (currentProduct) {
				dispatch(setIdCurrentProduct(currentProduct[0]?.cp_id))
				setCurrentProduct(currentProduct)
			} else {
				dispatch(setIdCurrentProduct(null))
				setCurrentProduct([])
			}

		} else {
			dispatch(setIdCurrentProduct(null))
			setCurrentProduct([])
		}
	}, [selectorHome, isMobile]);

	// Tách riêng việc lấy lịch sử đấu giá: chạy khi idCurrentProduct (được set ở
	// effect trên) THỰC SỰ đổi trong store — nếu đặt chung effect trên thì
	// selectorRightWeb.idCurrentProduct trong closure vẫn là giá trị cũ (null lúc
	// mount) nên getHistoryBid không bao giờ được gọi.
	useEffect(() => {
		if (selectorRightWeb.idCurrentProduct) {
			dispatch(getHistoryBid({
				query: {
					current: page,
					pageSize: 7,
					sort: sort,
					cp_ids: selectorRightWeb.idCurrentProduct,
				},
			}))
		} else {
			dispatch(resetBidHistory())
		}
	}, [selectorRightWeb.idCurrentProduct, page, sort]);

	return (
		<Home
			currentProduct={currentProduct?.[0]}
			selectedProduct={selectedProduct}
			results={results}
			account={selectorAccount}
			bidHistory={selectorRightWeb.bidHistory}
		/>
	)
}

export default HomePage;

const Container = styled.div`
	.slick-dots li button:before{
		display: none;
	}
`